export type OTPType = 'email' | 'sms' | 'ga';

// Heading and sentence of the code-entry page for each kind of code; `$` is replaced by the
// number, email or app name the code went to.
export const OTP_TITLE: Record<OTPType, string> = {
  email: 'تایید ایمیل',
  sms: 'تایید شماره همراه',
  ga: 'تائید Google Authenticator'
};

export const OTP_DESCRIPTION: Record<OTPType, string> = {
  email: 'کد ارسال شده به ایمیل $ را وارد کنید.',
  sms: 'کد ارسال شده به شماره $ را وارد کنید.',
  ga: 'کد $ را وارد کنید.'
};
